import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';
import { css } from '@linaria/core';

const keywordFilter = css`
  padding: 20px 0 20px 0;

  @media (min-width: 1080px) {
    padding: 0 0 20px 0;
  }

  & > div {
    margin-bottom: 0;
  }
`;

function ResearchReportsKeywordFilter({ addFilter, removeFilter, filters }) {
  return (
    <div className={keywordFilter}>
      <MultiChoiceAsyncSelect
        addFilter={addFilter}
        fieldId="keyword"
        filters={filters}
        id="keyword"
        label="Research categories"
        removeFilter={removeFilter}
      />
    </div>
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(ResearchReportsKeywordFilter);
